/* eslint-disable no-undef */
import Vue from 'vue'
import api from '../api'

export const UPDATE_DELIVERY_ADDRESS = 'UPDATE_DELIVERY_ADDRESS' // 更新配送地址
export default {
  state: {
    addresses: []
  },
  mutations: {
    [UPDATE_DELIVERY_ADDRESS] (state, data) {
      Object.assign(state, data)
      Vue.set(state, 'addresses', data)
    }
  },
  actions: {
    [UPDATE_DELIVERY_ADDRESS] ({commit}, userInfo) {
      return new Promise(function (resolve, reject) {
        api.getUserDeliveryAddress(userInfo).then((data) => {
          commit(UPDATE_DELIVERY_ADDRESS, data.list ? data.list : [])
          resolve()
        }, (data) => {
          reject(data)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/delivery-address.js